module.exports = __webpack_public_path__ + "static/antd-table-bordered-290a1ce4689f077cea7445ea99084b7b.png";